import { useEffect } from "react";

/**
 * Sends the legacy `/home` route to the server so the isolated HomeV2 bundle is
 * served. Needed because the legacy marketing pages link home with react-router
 * `<Link to="/">`, which would otherwise client-render the retired homepage.
 *
 * @returns {import("react").ReactNode} null
 */
export function HomeRedirect() {
  useEffect(() => {
    window.location.replace("/home");
  }, []);

  return null;
}
